import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  footer: {
    background: theme.palette.custom.background.dark,
    marginTop: 'auto',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
  },
  box: {
    ...dFlex('space-between', 'center'),
    paddingBottom: 76,
    paddingTop: 76,
    position: 'relative',
    zIndex: 1,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
      flexDirection: 'column',
      paddingBottom: 76,
      paddingTop: 76,
      gap: 16,
    },
  },
  logo: {
    height: 40,
    width: 140,
  },

  right: {
    ...dFlex('unset', 'flex-end'),
    flexDirection: 'column',
    gap: '16px',

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
    },
  },
  left: {
    maxWidth: 285,
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  footerSocials: {
    ...dFlex('flex-end', 'center'),
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
    },
  },
  icon: {
    svg: {
      path: {
        fill: theme.palette.custom.text.dark,
      },
    },
  },
  mothershipIcon: {
    alignSelf: 'flex-end',
    marginBottom: 2,
    // The shared Link anchor has `gap: 8px`; the design gap is 4px.
    marginLeft: -4,
    fontSize: 16,
    color: theme.palette.custom.buttons.darkHover,
  },
  link: {
    ...dFlex('center', 'center'),
    gap: '4px',

    svg: {
      color: theme.palette.custom.text.dark,
    },
  },
}));

export default useStyles;
